<template>
  <div>
    <div id="modalBody">
      <div class="leftCol">
        <CCard>
          <CCardHeader>User Details</CCardHeader>
          <CCardBody>
            <div class="field">
              <div class="label details">First Name:</div>
              <DxTextBox
                ref="userFirstName"
                class="details"
                :disabled="readOnly"
                :value.sync="userFirstName"
              />
            </div>
            <div class="field">
              <div class="label details">Last Name:</div>
              <DxTextBox
                ref="userLastName"
                class="details"
                :disabled="readOnly"
                :value.sync="userLastName"
              />
            </div>
            <div class="field">
              <div class="label details">Title:</div>
              <DxTextBox
                ref="userTitle"
                class="details"
                :disabled="readOnly"
                :value.sync="userTitle"
              />
            </div>
            <div class="buttons">
              <DxButton
                text="Save Changes"
                type="default"
                :disabled="readOnly"
                @click="updateUser"
              />
              <DxButton text="Cancel" @click="$emit('hide-modal')" />
            </div>
          </CCardBody>
        </CCard>
      </div>
      <div class="rightCol">
        <CCard>
          <CCardHeader>Change Password</CCardHeader>
          <CCardBody>
            <form @submit="changePassword($event)">
              <div class="field">
                <div class="label password">Current Password:</div>
                <DxTextBox
                  ref="currentPassword"
                  class="password"
                  mode="password"
                  :value.sync="currentPassword"
                >
                  <DxValidator>
                    <DxRequiredRule message="Current Password is required" />
                  </DxValidator>
                </DxTextBox>
              </div>
              <div class="field">
                <div class="label password">New Password:</div>
                <DxTextBox
                  ref="newPassword"
                  id="newPassword"
                  class="password"
                  mode="password"
                  :value.sync="newPassword"
                >
                  <DxValidator>
                    <DxRequiredRule message="New Password is required" />
                    <DxStringLengthRule
                      :min="8"
                      message="Password must be at least 8 characters"
                    />
                    <DxPatternRule
                      :pattern="passwordPattern"
                      message="Password Must Contain: At least 1 lowercase and uppercase letter, 1 number "
                    />
                  </DxValidator>
                </DxTextBox>
              </div>
              <div class="field">
                <div class="label password">Confirm Password:</div>
                <DxTextBox
                  ref="confirmPassword"
                  id="confirmPassword"
                  class="password"
                  mode="password"
                  :value.sync="confirmPassword"
                >
                  <DxValidator>
                    <DxRequiredRule message="Please Confirm Password" />
                    <DxStringLengthRule
                      :min="8"
                      message="Password must be at least 8 characters"
                    />
                    <DxPatternRule
                      :pattern="passwordPattern"
                      message="Password Must Contain: At least 1 lowercase and uppercase letter, 1 number "
                    />
                    <DxCompareRule
                      :comparison-target="comparePasswords"
                      message="Passwords do not match"
                    />
                  </DxValidator>
                </DxTextBox>
              </div>
              <div class="buttons">
                <DxButton
                  text="Save Changes"
                  type="default"
                  :use-submit-behavior="true"
                />
                <DxButton text="Cancel" @click="$emit('hide-modal')" />
              </div>
            </form>
          </CCardBody>
        </CCard>
      </div>
    </div>
  </div>
</template>

<script>
import { DxTextBox } from "devextreme-vue/text-box";
import { DxButton } from "devextreme-vue/button";
import {
  DxValidator,
  DxRequiredRule,
  DxCompareRule,
  DxPatternRule,
  DxStringLengthRule,
} from "devextreme-vue/validator";
import { EventBus } from "../../components/Events.js";

export default {
  name: "ManageAccount",
  components: {
    DxTextBox,
    DxButton,
    DxValidator,
    DxRequiredRule,
    DxCompareRule,
    DxPatternRule,
    DxStringLengthRule,
  },
  data() {
    return {
      user: this.$auth.user,
      currentPassword: null,
      newPassword: null,
      confirmPassword: null,
      userTitle: this.$auth.user.UserDetails.Title,
      userFirstName: this.$auth.user.UserDetails.FirstName,
      userLastName: this.$auth.user.UserDetails.LastName,
      readOnly: true,
      passwordPattern: /^(?=.*[\d])(?=.*[A-Z])(?=.*[a-z]).{8,}$/,
    };
  },
  methods: {
    comparePasswords() {
      return this.newPassword;
    },
    async changePassword(e) {
      e.preventDefault();
      this.$axios
        .get(
          `https://api.ccr.net/Auth/ResetPassword(${this.user.email},${this.newPassword})`
        )
        .then((response) => {
          if (response.data.Status) {
            EventBus.$emit(
              "show-confirmation",
              "Password Changed Successfully"
            );
          }
        });
    },
    async updateUser(e) {
      e.event.preventDefault();
    },
  },
};
</script>

<style lang="scss" scoped>
#modalBody {
  display: flex;
  justify-content: space-between;

  .leftCol {
    width: 49.2%;
  }

  .rightCol {
    width: 49.2%;
  }

  .card-header {
    background-color: #f5f5f5;
    height: 39px;
    padding: 0.5rem 1rem;
    font-weight: 500;
    color: #444;
    border-color: #c4c9d0;
  }

  .card-body {
    padding-top: 10px;
  }
}

.field {
  margin-top: 10px;
}

.label.details {
  width: 30%;
  display: inline-block;
}

.dx-textbox.details {
  width: 70%;
  display: inline-block;
}

.label.password {
  width: 40%;
  display: inline-block;
}

.dx-textbox.password {
  width: 60%;
  display: inline-block;
}

.buttons > .dx-button {
  float: right;
  margin: 20px 5px 0px 5px;
  font-size: 12px;
  padding: 4px 10px;
}
</style>